import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { SessionStorageService } from '../session-storage/session-storage.service';

/**
 * Service that stores and provides a key-value collection across the whole app.
 * It should be used to keep the app state and share data between components that
 * are not part of the same module
 *
 */

@Injectable({
  providedIn: 'root',
})
export class StateHandlerService {
  private stateData: Array<any> = [];

  constructor(private readonly sessionStore: SessionStorageService) {}

  /**
   * Returns stored data as an observable
   * @param key: string
   */
  get(key: any): Observable<any> {
    this.stateData[key] =
      this.sessionStore.get(key) &&
      new BehaviorSubject(this.sessionStore.get(key));
    if (!this.stateData[key]) {
      // TODO review possibility of returning an error instead
      this.set(key, '', false);
    }
    return this.stateData[key].asObservable().pipe(delay(50));
  }
  /**
   * Get sin observable
   * @param key
   * @returns
   */
  getWithoutObs(key: any): any {
    if (!this.stateData[key]) {
      // TODO review possibility of returning an error instead
      this.set(key, '', false);
    }
    return this.stateData[key].getValue();
  }
  /**
   * Sets provided data identified by its key
   * @param key: string
   * @param value: any
   * @param persistStore: boolean
   */
  set(key: any, value: any, persistStore = true) {
    if (!this.stateData[key]) {
      this.stateData[key] = new BehaviorSubject(value);
    }
    // tslint:disable-next-line:no-unused-expression
    persistStore && this.sessionStore.set(key, value);
    this.stateData[key].next(value);
  }

  nextValue(key: any, value: any) {
    this.stateData[key].next(value);
  }
}
